/* global Swiper */

Wee.fn.make('quotes', {
	init: function() {
		var scope = this;

		scope.$swiper = $('.js-swiper-quotes')[0];

		$.screen.map([
			{
				max: 2,
				callback: function() {
					scope.destroySwiper();
					scope.initSwiper(1, 1);
				}
			},
			{
				max: 4,
				callback: function() {
					scope.destroySwiper();
					scope.initSwiper(2, 2);
				}
			},
			{
				size: 5,
				callback: function() {
					scope.destroySwiper();
					scope.initSwiper(2, 3);
				}
			},
			{
				size: 6,
				callback: function() {
					scope.destroySwiper();
					scope.initSwiper(2, 4);
				}
			}
		]);
	},

	initSwiper: function(slidesPerColumn, slidesPerView) {
		this.quotesSwiper = new Swiper('.js-swiper-quotes', {
			slidesPerColumn: slidesPerColumn,
			slidesPerView: slidesPerView,
			slidesPerColumnFill: 'row',
			spaceBetween: 20,
			pagination: '.js-swiper-quotes-pagination',
			paginationClickable: true,
			nextButton: '.js-swiper-quotes-button-next',
			prevButton: '.js-swiper-quotes-button-prev'
		});

		this.quotesSwiper.slideTo(0);
	},

	destroySwiper: function() {
		if (this.quotesSwiper) {
			this.quotesSwiper.destroy(true, true);
		}
	},

	unload: function() {
		this.destroySwiper();
	}
});
